import { useInfiniteQuery } from 'react-query';
import { queryGet } from '@pocapan/shared/utils/queryClient';

const DEFAULT_PAGE = 20;

export function useFollowersQuery(userProfileId, perPage = DEFAULT_PAGE) {
  const fetchFollowers = async ({ pageParam = 1 }) => {
    const queryParams = createQueryParams({ userProfileId, perPage, pageParam });
    const url = `/api/v1/user_profiles/${userProfileId}/followers?${queryParams.toString()}`;

    try {
      return await queryGet(url);
    } catch (_error) {
      throw new Error('사용자 프로필 검색 중 오류가 발생했습니다.');
    }
  };

  return useInfiniteQuery(['Followers', userProfileId], fetchFollowers, {
    enabled: !!userProfileId,
    getNextPageParam: (lastPage) => lastPage?.meta?.pagination?.nextPage || undefined
  });
}

export function useFollowingsQuery(userProfileId, perPage = DEFAULT_PAGE) {
  const fetchFollowings = async ({ pageParam = 1 }) => {
    const queryParams = createQueryParams({ userProfileId, perPage, pageParam });
    const url = `/api/v1/user_profiles/${userProfileId}/followings?${queryParams.toString()}`;

    try {
      return await queryGet(url);
    } catch (_error) {
      throw new Error('사용자 프로필 검색 중 오류가 발생했습니다.');
    }
  };

  return useInfiniteQuery(['Followings', userProfileId], fetchFollowings, {
    enabled: !!userProfileId,
    getNextPageParam: (lastPage) => lastPage?.meta?.pagination?.nextPage || undefined
  });
}

// 쿼리 파라미터 생성 함수
function createQueryParams({ userProfileId, perPage, pageParam }) {
  return new URLSearchParams({
    userProfileId,
    per_page: perPage,
    page: pageParam
  });
}
